import styled from "styled-components"

import { Tooltip } from "components/common/Tooltip"

export const CardContainer = styled.div<{ isRead: boolean; isClickable: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background-color: ${({ isRead }) => (isRead ? "#ffffff" : "#f8fafc")};
  border-bottom: 1px solid var(--border-default);
  cursor: pointer;
  ${({ isClickable }) => !isClickable && "cursor: default;"}

  &:hover {
    background-color: var(--surface-3);
  }
`

export const NotificationContainer = styled.div`
  display: flex;
  flex: 1 0 0;
  gap: 16px;
  align-items: flex-start;
  min-width: 0;
`

export const AvatarWrapper = styled.div<{ type: "email" | "positive" | "warning" | "report" | "perftest" }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  flex-shrink: 0;
  background-color: ${({ type }) => {
    switch (type) {
      case "positive":
        return "#dcfce7"
      case "warning":
        return "#fef3c7"
      case "report":
      case "perftest":
        return "#dbeafe"
      default:
        return "#e2e8f0"
    }
  }};

  svg {
    width: 20px;
    height: 20px;
    color: ${({ type }) => {
      switch (type) {
        case "positive":
          return "#15803d"
        case "warning":
          return "#b45309"
        case "report":
          return "#3b82f6"
        default:
          return "#334155"
      }
    }};

    path {
      ${({ type }) => (type === "perftest" ? "fill: none; stroke: currentColor;" : "fill: currentColor;")}
    }
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: 12px;
  align-self: stretch;
  min-width: 0;
`

export const NotificationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const Title = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.084px;
  color: var(--text-primary);
  width: 100%;
  word-wrap: break-word;
`

export const Subtext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`

export const SubtextLine = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.084px;
  color: var(--text-secondary);
`

export const DeviceLocationLine = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.084px;
  color: var(--text-muted);
`

export const ReportLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.084px;
  color: var(--accent);

  svg {
    width: 14px;
    height: 14px;
  }
`

export const TimeStamp = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--text-muted);
  white-space: nowrap;
`

export const IconContainer = styled.div<{ isRead: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px;
  border: 1px solid var(--border-strong);
  border-radius: 56px;
  flex-shrink: 0;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--surface-3);
  }
`

export const StyledTooltip = styled(Tooltip)`
  position: absolute;

  span {
    display: none;
  }

  div {
    height: 20px;
    min-height: 20px;
    display: flex;
    align-items: center;
  }
`

export const ReadIndicator = styled.div<{ isRead: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 100px;
  background-color: ${({ isRead }) => (isRead ? "transparent" : "#2db2c8")};
`

export const IssueTest = styled.span`
  color: var(--status-danger);
  font-weight: 500;
`

export const CustomerName = styled.span`
  font-weight: 600;
`
